module.exports = __webpack_public_path__ + "static/img/people5.2e84345.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/people5.jpg
// module id = Ymd0
// module chunks = 1